import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IPaginatedUserActivity } from "../../features/UserActivity/interface";

interface IRecentActivityParams {
  action_type?: string;
  from_date?: string;
  to_date?: string;
  page?: number;
  per_page?: number;
  user_id?: string;
}

const fetchRecentActivity = async (params: IRecentActivityParams) => {
  const response = await httpService.get<IPaginatedUserActivity>(
    API_CONFIG.path.userActivity,
    params as Record<string, string | number>
  );
  return response;
};

export const useRecentActivity = (params: IRecentActivityParams = {}) => {
  return useQuery({
    queryKey: ["recentActivity", params],
    queryFn: () => fetchRecentActivity(params),
    placeholderData: (previousData) => previousData,
    // Cache for 10 minutes
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
